import DiscoverFilterDialogFooter from './DiscoverFilterDialogFooter';

export default DiscoverFilterDialogFooter;
